import { createFileRoute } from '@tanstack/react-router'

import { AgentsNotReady } from '#/modules/agents/agents-not-ready'
import { validateListSearch } from '#/shared/lib/list-search'

// The Agents section is switched off — see `agents-not-ready.tsx`. Pointing the
// route at the placeholder is what guarantees no request goes out: the real
// page's queries never mount.
export const Route = createFileRoute('/_shell/skills')({
  component: AgentsNotReady,
  validateSearch: validateListSearch,
})
